import React from "react";

export default function ServicePeriod({ product, onClick }) {
	return (
		<button
			type="button"
			onClick={onClick}
			className="w-100 border-0 text-white text-center position-relative overflow-hidden"
			style={{
				backgroundImage: "linear-gradient(130deg, #009845 0%, #FFE200 100%)",
				borderRadius: 8,
				padding: "16px 12px",
				cursor: "pointer",
			}}
		>
			{!!product.Promote?.trim() && (
				<span
					className="position-absolute text-uppercase fw-bold text-white"
					style={{
						top: 26,
						right: -54,
						width: 200,
						backgroundColor: "#DC3545",
						transform: "rotate(45deg)",
						fontSize: 12,
						padding: "4px 0",
					}}
				>
					{product.Promote}
				</span>
			)}
			<div className="fw-bold">{product.Name}</div>
			<div className="h4 mb-0">R {product.Price.toFixed(0)}</div>
		</button>
	);
}
